import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 51,
    seconds: 46
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          // Reset when it hits 0
          return {
            hours: 23,
            minutes: 51,
            seconds: 46
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className={`flex gap-3 justify-center ${className}`} data-id="element-229">
      <div className="flex flex-col items-center" data-id="element-230">
        <div className="bg-white text-red-600 font-bold text-2xl md:text-3xl px-4 py-3 rounded-lg shadow-lg min-w-[70px] text-center" data-id="element-231">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <span className="text-xs mt-1 font-medium" data-id="element-232">Horas</span>
      </div>
      <div className="flex flex-col items-center" data-id="element-233">
        <div className="bg-white text-red-600 font-bold text-2xl md:text-3xl px-4 py-3 rounded-lg shadow-lg min-w-[70px] text-center" data-id="element-234">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <span className="text-xs mt-1 font-medium" data-id="element-235">Min</span>
      </div>
      <div className="flex flex-col items-center" data-id="element-236">
        <div className="bg-white text-red-600 font-bold text-2xl md:text-3xl px-4 py-3 rounded-lg shadow-lg min-w-[70px] text-center" data-id="element-237">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <span className="text-xs mt-1 font-medium" data-id="element-238">Seg</span>
      </div>
    </div>;
}